
import "regenerator-runtime/runtime";

if(module && module.hot){
    module.hot.accept();
}

import Vue from 'vue';
window.Vue = Vue;

window.formatPrice = price => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
Vue.filter('price', formatPrice);

var shimmedGlobal = require('globalthis').shim();
window.IMask = require('imask/esm/imask').default;
import 'imask/esm/masked/regexp';

import 'tingle.js/dist/tingle.min.css';
window.tingle = require('tingle.js');

import './scss/main.scss';
import './js/main';